/**
  @prop --cbp-banner-color: var(--cbp-color-text-lightest);
  @prop --cbp-banner-color-bg: var(--cbp-color-info-dark);
*/
:root {
  --cbp-banner-color: var(--cbp-color-text-lightest);
  --cbp-banner-color-bg: var(--cbp-color-info-dark);
}

cbp-banner {
  display: flex;
  flex-direction: row;
  gap: var(--cbp-space-4x);
  padding: var(--cbp-space-4x) var(--cbp-responsive-spacing-outer);
  background-color: var(--cbp-banner-color-bg);

  .cbp-banner-icon-container {
    align-content: center;
  }

  .cbp-banner-text-container {
    color: var(--cbp-banner-color);

    &>p {
      margin-block-end: var(--cbp-space-3x);
    }
  }

  &[color=info] {
    --cbp-banner-color: var(--cbp-color-text-lightest);
    --cbp-banner-color-bg: var(--cbp-color-info-dark);
  }
}